import { Component } from 'react';
import './HTSModal.less';

class HTSModal extends Component {
  render() {
    return null;
  }
}
export default HTSModal;
